import { LANG_TRANSLATOR } from '../../../config/translator';
export class CareOrderBabyFormForCareRequirementPage {
    #careOrderBabyForm;
    constructor({ careOrderBabyForm }) {
        this.#careOrderBabyForm = careOrderBabyForm;
    }
    get parsedLang() {
        const lang = this.#careOrderBabyForm.lang;
        if (!lang)
            return '';
        const parsedLang = LANG_TRANSLATOR[lang];
        return parsedLang;
    }
    get parsedServedItem() {
        const servedItem = this.#careOrderBabyForm.servedItem;
        if (!servedItem)
            return '';
        const parsedServedItem = servedItem.join(', ');
        return parsedServedItem;
    }
}
